import React from 'react';
import dayjs from 'dayjs';
import { FiAlertCircle, FiClock } from 'react-icons/fi';
import type { MetaWindow } from '../../services/MetaMessagesService';
import './metaConversation.css';

export const WINDOW_CLOSED_TEXT = 'Fora do prazo da Meta: o cliente precisa mandar mensagem primeiro.';

interface Props {
  /** Só o estado e o prazo importam (o WhatsApp oficial monta a janela no próprio navegador). */
  window: (Pick<MetaWindow, 'state' | 'untilUtc'> & Partial<MetaWindow>) | null;
  error?: string | null;
  /** Texto da janela fechada, quando não é o da Meta (ex.: WhatsApp oficial). */
  closedText?: string;
}

const until = (iso: string | null) => (iso ? dayjs(iso).format('DD/MM [às] HH:mm') : '');

/** Faixa sobre o compositor da Meta: aberta, só com Human Agent (fora das 24 h) ou fechada. */
export const MetaWindowNotice: React.FC<Props> = ({ window: w, error, closedText }) => {
  if (error) {
    return (
      <div className="meta-window meta-window-error" role="alert">
        <FiAlertCircle size={14} aria-hidden="true" /> {error}
      </div>
    );
  }
  if (!w) return null;
  if (w.state === 'closed') {
    return (
      <div className="meta-window meta-window-closed" role="status">
        <FiAlertCircle size={14} aria-hidden="true" /> {closedText ?? WINDOW_CLOSED_TEXT}
      </div>
    );
  }
  if (w.state === 'human_agent_only') {
    return (
      <div className="meta-window meta-window-human" role="status">
        <FiClock size={14} aria-hidden="true" /> Passou o prazo de 24 h. Como atendimento humano (Human Agent), você ainda pode responder até {until(w.untilUtc)}.
      </div>
    );
  }
  return (
    <div className="meta-window meta-window-open" role="status">
      <FiClock size={14} aria-hidden="true" /> Você pode responder até {until(w.untilUtc)}.
    </div>
  );
};
